export default __webpack_public_path__ + "static/media/notes.4dc84201.svg";